import {
	WhitelistNameEnum,
	WhitelistTypeEnum,
} from '../interfaces/whitelist.interface';

const CURP_REGEX =
	/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

export const normalizeWhitelistValue = (
	type: WhitelistTypeEnum,
	value: string,
): string => {
	const trimmed = value.trim();
	return type === WhitelistTypeEnum.curp ? trimmed.toUpperCase() : trimmed;
};

export const isValidWhitelistValue = (
	type: WhitelistTypeEnum,
	value: string,
): boolean => {
	if (type === WhitelistTypeEnum.curp) {
		return CURP_REGEX.test(value);
	}
	return value.trim().length > 0;
};

const REQUIRED_TYPE_BY_NAME: Record<WhitelistNameEnum, WhitelistTypeEnum> = {
	[WhitelistNameEnum.creditLine]: WhitelistTypeEnum.folio,
	[WhitelistNameEnum.payJoyEmployees]: WhitelistTypeEnum.curp,
	[WhitelistNameEnum.abandonedCart]: WhitelistTypeEnum.curp,
};

export const getRequiredTypeForName = (
	name: WhitelistNameEnum,
): WhitelistTypeEnum | null => REQUIRED_TYPE_BY_NAME[name] ?? null;
